import { render, staticRenderFns } from "./CarroMini.vue?vue&type=template&id=7f109253&"
import script from "./CarroMini.vue?vue&type=script&lang=js&"
export * from "./CarroMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports